import { Translator } from "./translator";
import { DeliveryMethod, getDeliveryMethodText } from "domain/deliveryMethod";
import { CommodityBalanceType, getDeliveryMethod } from "domain/commodityBalance";
import { getPaymentOptionDisplayName, PaymentOption } from "domain/paymentOption";
import useDeliveryMethods from "features/deliveryMethods/useDeliveryMethods";
import { usePaymentOptions } from "features/merchants/usePaymentOptions";

export interface TranslatorCollection {
    deliveryMethods: Translator<DeliveryMethod>;
    commodityBalanceTypes: Translator<CommodityBalanceType>;
    paymentOptions: Translator<PaymentOption>;
}

export default function useTranslators(): TranslatorCollection {
    const deliveryMethods = useDeliveryMethods();
    const paymentOptionsDetails = usePaymentOptions();

    return {
        deliveryMethods: {
            translate: val => getDeliveryMethodText(val, deliveryMethods)
        },
        commodityBalanceTypes: {
            translate: val => getDeliveryMethodText(getDeliveryMethod(val), deliveryMethods)
        },
        paymentOptions: {
            translate: val => getPaymentOptionDisplayName(val, paymentOptionsDetails),
        },
    };
}